import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";
import { useQuery } from "react-query";

import type { LayoutPartialsData } from "@/react/components/Layout/MobileDrawer/types";
import { internalApi } from "@/react/helpers/urlHelpers";

export interface LayoutPartialsContextProps {
  data?: LayoutPartialsData;
  error?: unknown;
  isPending?: boolean;
}

const LayoutPartialsContext = createContext<LayoutPartialsContextProps>({});
LayoutPartialsContext.displayName = "LayoutPartialsContext";

export const LayoutPartialsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { data, error, isPending } = useQuery<LayoutPartialsData>({
    queryKey: [internalApi.layoutPartials.show()],
  });

  const contextValue = useMemo(
    () => ({ data, error, isPending }),
    [data, error, isPending],
  );

  return (
    <LayoutPartialsContext.Provider value={contextValue}>
      {children}
    </LayoutPartialsContext.Provider>
  );
};

export const useLayoutPartialsContext = () => useContext(LayoutPartialsContext);
